
      import Location from './location.vue'
      import type { App, Plugin } from 'vue'

      export const LocationPlugin: Plugin = {
        install(app: App) {
          app.component('Location', Location)
        },
      }
      export { Location }
      